import { Stack, Typography } from "@mui/material";
import { FormattedMessage } from "react-intl";

import { IgniteLogo } from "../IgniteLogo";

export const PoweredByFooter: React.FC = () => {
    return (
        <Stack alignItems="center" gap={1}>
            <Stack direction="row" alignItems="center" gap={1}>
                <Typography variant="textMd" fontWeight={500} color="text.secondary">
                    <FormattedMessage defaultMessage="Powered by" />
                </Typography>
                <IgniteLogo size="small" color="secondary" />
            </Stack>
            <Typography variant="textSm" textAlign="center" color="textTextHelper">
                <FormattedMessage defaultMessage="The leading platform for procurement & supplier intelligence" />
            </Typography>
        </Stack>
    );
};
